import React from 'react';

export const RouteNameContext = React.createContext<string | undefined>(undefined);

export default RouteNameContext;

